//import React from 'react';
import React, { useEffect, useState } from 'react';
import axios from "axios";
import { Button, Card, Form, Input, Modal } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import _ from 'underscore';
import { history } from '../../redux/store';
import setting from '../../config/setting'
import { Spin, Space, Row, Col, Divider, Tooltip } from 'antd';
import moment from "moment";
import {  version } from "antd";
import { Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import {
  Alert,
  AutoComplete,
  // Button,
  //Card,
  Checkbox,
  //Input,
  Radio,
  Rate,
  Select,
  Switch,
  Tag,
  //Form,
  DatePicker
} from 'antd';

import {

  PlusCircleTwoTone,
} from '@ant-design/icons';
//import { Button, Card, Form, Input } from 'antd';
import { LockOutlined, MailOutlined, UserOutlined } from '@ant-design/icons/lib';

import { usePageData } from '../../hooks/usePage';
import { IPageData } from '../../interfaces/page';
const FormItem = Form.Item;
const { Option } = Select;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 }
  }
};



const TrainingView = () => {

  const [eventid,setEventid]= useState("123");
  const [compNameN, setcompName] = useState('');
  const [location,setLocation]=useState("");
  const [employee,setEmployee]=useState("");
  const [sex, setSex] = useState('');
  const [dob,setDob] = useState('');
  const [emailN, setemail] = useState('');
  const [first_name,setFirst_Name]=useState("");
  const [test_date,setTestDate]=useState("");
  const [test_type,setTestType]=useState("");
  const [photo_pdf,setPhotoPdf]=useState("");
  const [testing_status,setTesting_Status]=useState("");
  const [testing_result,setTesting_result]=useState("");
  


  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };


  useEffect(() => {

    
  }, [])

  


  //usePageData(pageData);
  return (

    <div>
      <Row>
        <Col span={6}>
          <h3 style={{ padding: 10, textAlign: 'left' }}>Training</h3>
        </Col>
        <Col span={8}>


        </Col>
      </Row>
      



    </div>
  );
};

export default TrainingView;
